import React, { useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Card, CardBody,
  CardTitle, CardSubtitle,
  CardText, CardHeader,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  TabContent,
  TabPane,
  Row,
  Col,
  Input,
  Table,
  Alert,
} from "reactstrap"
import Select from "react-select"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import cogoToast from 'cogo-toast';

import Moment from "moment";
import { extendMoment } from 'moment-range';
import { connect } from "react-redux"

const moment = extendMoment(Moment);

const NewPpmactivity = props => {

  const history = useHistory();

  const [freqTab, setFreqTab] = useState(0);

  const [activityName, setActivityName] = useState('');
  const [activityCode, setActivityCode] = useState('');
  const [serviceType, setServiceType] = useState(null);
  const [selectedGroups, setSelectedGroups] = React.useState([]);
  const [selectedAssets, setSelectedAssets] = React.useState([]);

  const [vendor, setVendor] = useState(null);
  const [contract, setContract] = useState(null);

  const [startDate, setStartDate] = React.useState(moment().add(1, 'day').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = React.useState(moment().add(1, 'day').add(1, 'year').format('YYYY-MM-DD'));
  const [overdue, setOverdue] = React.useState(1);
  // const [duration, setDuration] = React.useState(30);
  const [enableOverdue, setEnableOverdue] = useState(false);
  const [type, setType] = useState('Monthly');

  const [enableRepeat, setEnableRepeat] = useState(true);
  const [repeatVal, setRepeatVal] = useState(4);
  const [repeatUnit, setRepeatUnit] = useState('Weeks');
  const [durationVal, setDurationVal] = useState(4);
  const [durationUnit, setDurationUnit] = useState('Weeks');

  const [assets, setAssets] = React.useState([]);
  const [groups, setGroups] = React.useState([]);
  const [forms, setForms] = React.useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [vendors, setVendors] = React.useState([]);
  const [contracts, setContracts] = React.useState([]);

  const [formId, setFormId] = React.useState(null);
  const [fields, setFields] = React.useState([]);


  const units = [
    'weeks', 'months', 'years'
  ];




  const [errors, setErrors] = React.useState([]);

  const [loading, setLoading] = React.useState(true);
  const [initializing, setInitializing] = React.useState(true);
  const [formloading, setFormLoading] = React.useState(false);




  const fetchData = (id) => {
    setLoading(true);
    console.log('Fetching ', id);
    get(url.GET_PPMACTIVITY + '/' + id).then(response => {
      console.log('fRESP', response);
      // return;

      if (response.status == 200) {
        if (response.data) {
          setActivityName(response.data.name);
          setActivityCode(response.data.activity_code);
          setServiceType(response.data.servicetype_id);
          setVendor({ value: response.data.vendor.id, label: response.data.vendor.name });
          const contractRes = response.data.contracts.find((c) => { c.id === response.data.contract_id });
          if (contractRes) {
            setContract({ value: contractRes.id, label: contractRes.contract_type, end_date: contractRes.end_date });
          }
          // TODO: Test ^, Contract start, end dates display under text field
          setSelectedGroups(response.data.groups.map(a => ({ value: a.id, label: a.name })));
          setSelectedAssets(response.data.assets.map(a => ({ value: a.id, label: a.name })));
          setStartDate(response.data.start_date);
          setEndDate(response.data.end_date);
          setType(response.data.type);
          setDurationVal(response.data.duration_val);
          setDurationUnit(response.data.duration_unit);

          if (response.data.repeat_val && response.data.repeat_unit) {
            setEnableRepeat(true);
            setRepeatVal(response.data.repeat_val);
            setRepeatUnit(response.data.repeat_unit);
          }
          else {
            setEnableRepeat(false);
            setRepeatVal(null);
            setRepeatUnit(null);
          }

          if (response.data.overdue) {
            setEnableOverdue(true);
            setOverdue(response.data.overdue);
          }
          else {
            setEnableOverdue(false);
            setOverdue(null);
          }

          setFormId({ value: response.data.form_id, label: response.data.form.name });
          fetchForm(response.data.form_id);
        }
        else {
          cogoToast.error('Could not fetch activity data');
        }
        setLoading(false);
      }
      else {
        cogoToast.error('Could not fetch activity data');
        setLoading(false);
      }
    })
      .catch(error => {
        console.log('err:', error);
      });
  };

  const init = () => {
    setInitializing(true);
    get(url.GET_NEW_PPMACTIVITY + '/' + props.filterBlock.id).then(response => {
      console.log('RESP', response);
      if (response.status == 200) {
        setAssets(response.data.assets);
        setGroups(response.data.groups);
        setForms(response.data.forms);
        setServiceTypes(response.data.servicetypes);
        setVendors(response.data.vendors);
        setContracts(response.data.contracts);

        setInitializing(false);
      }
      else {
        cogoToast.error('Could not fetch data');
        setInitializing(false);
      }
    })
      .catch(error => {
        console.log('err:', error);
      });

  }



  const fetchForm = (id) => {
    // console.log('Fetch Form:', id);
    setFormLoading(true);
    get(url.GET_FORM + '/' + id).then(response => {
      console.log('RESP', response);
      if (response.status == 200) {
        setFields(response.data.fields);
        // setForm(response.data.form);
        setFormLoading(false);
      }
      else {
        console.log('err::', response);
      }
    })
      .catch(error => {
        console.log('err:', error);
      });
  };


  const handleSubmit = () => {
    if (activityName == '') {
      cogoToast.error('Activity name is required');
      return;
    }
    if (activityCode == '') {
      cogoToast.error('Activity code is required');
      return;
    }

    if (formId == null) {
      cogoToast.error('A form should be selected!');
      return;
    }

    if (contract == null) {
      cogoToast.error('A contract should be selected!');
      return;
    }

    if (!selectedAssets || selectedAssets.length < 1) {
      cogoToast.error('Please choose some assets');
      return;
    }

    if (moment(endDate) <= moment(startDate)) {
      cogoToast.error('End date cannot be before Start date');
      return;
    }

    if (moment(endDate) > moment(contract.end_date)) {
      cogoToast.error('End date cannot be after Contract Expiry');
      return;
    }

    // console.log(isNaN(duration));
    // console.log(duration < 1);
    // console.log(duration < 1);
    // console.log(enableOverdue, overdue, isNaN(overdue), duration);


    if (isNaN(durationVal) || durationVal < 1) {
      cogoToast.error('Please enter a valid task duration');
      return;
    }

    if (enableOverdue && (isNaN(overdue))) {
      cogoToast.error('Please enter a valid overdue value');
      return;
    }

    // if(parseInt(overdue) >= parseInt(duration)) {
    //   cogoToast.error('Overdue date cannot be longer than task duration');
    //   return;
    // } 
    // ^ TODO : Implement later



    let data = {
      id: props.match.params.id ? props.match.params.id : 'new',
      name: activityName,
      activity_code: activityCode,
      servicetype_id: serviceType,
      form_id: formId.value,
      groups: selectedGroups.map(g => g.value),
      assets: selectedAssets.map(a => a.value),
      start_date: startDate,
      end_date: endDate,
      type: type,
      repeat_val: (enableRepeat && !isNaN(repeatVal)) ? repeatVal : null,
      repeat_unit: (enableRepeat && !isNaN(repeatVal)) ? repeatUnit : null,
      duration_val: parseInt(durationVal),
      duration_unit: durationUnit,
      overdue: enableOverdue ? parseInt(overdue) : null,
      vendor_id: vendor.value,
      contract_id: contract.value,
      property_id: props.filterProperty.id,
      block_id: props.filterBlock.id,
    };

    console.log('data', data);

    // return;


    setLoading(true);
    setErrors([]);
    post(url.POST_NEW_PPMACTIVITY, data)
      .then((response) => {
        console.log('RESP', response);
        if (response.status == 200) {
          history.push('/ppmactivities/index');
          cogoToast.success('Activity ' + (props.match.params.id ? (props.match.params.id == 'new' ? 'added' : 'updated') : 'added') + ' successfully');
          // setLoading(false);
        }
        else if (response.status == 400) {
          // setErrors(Object.values(response.error));
        }
        else {
          console.log('err::', response);
        }
      }, (error) => {
        console.log(error);
        setLoading(false);
      });

  };


  React.useEffect(() => {
    console.log(props.filterBlock);
    if (props.filterBlock) {

      setSelectedAssets([]);
      setFormId(null);
      setSelectedGroups([]);
      setVendor(null);
      setContract(null);

      init();
    }
  }, [props.filterBlock]);

  React.useEffect(() => {
    if (props.match.params.id) {
      fetchData(props.match.params.id);
    }
  }, []);

  // const markedAssets = selectedAssets.filter(a => a.selected);
  const dispGroups = serviceType ? groups.filter(b => b.servicetype_id == serviceType) : [];
  const dispContracts = vendor ? contracts.filter(b => b.vendor_id == vendor.value) : [];

  const maxOverdue = moment(endDate).diff(moment(startDate), 'days');

  // console.log(startDate, endDate, maxOverdue);

  // console.log('dispGroups', serviceType, groups, dispGroups, selectedGroups);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.match.params.id ? (props.match.params.id == 'new' ? 'Add New' : 'Edit') : 'Add New'} PPM Activity | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">{props.match.params.id ? (props.match.params.id == 'new' ? 'New' : 'Edit') : 'New'} PPM Activity</h3>
            <Link className="btn btn-secondary" to="/ppmactivities/index">Back</Link>
          </div>


          {errors.length > 0 &&
            <div className="mt-3 mb-5">
              {errors.map((error, errorIdx) => (
                <Alert key={errorIdx} color="danger">
                  <i className="mdi mdi-alert-circle-outline me-2"></i>{error}
                </Alert>
              ))}
            </div>
          }

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">BASIC DETAILS</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row mt-2">
                <div className="col">
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label label-required">Activity Name</label>
                    <div className="col-sm-9">
                      <input autoFocus type="text" className="form-control" id="activityName" value={activityName} onChange={e => { setActivityName(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="activityCode" className="col-sm-3 col-form-label label-required">Activity Code</label>
                    <div className="col-sm-9">
                      <input type="text" className="form-control" id="activityCode" value={activityCode} onChange={e => { setActivityCode(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="property" className="col-sm-3 col-form-label label-required">Property</label>
                    <div className="col-sm-9">
                      <span className={(props.filterProperty && props.filterBlock) ? "text-success" : "text-danger"}>
                        {(props.filterProperty && props.filterBlock) ? (props.filterProperty.name + ' / ' + props.filterBlock.name) : 'Please select'}
                      </span>
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="serviceType" className="col-sm-3 col-form-label label-required">Activity Type</label>
                    <div className="col-sm-9">
                      <select className="form-control" placeholder="Select"
                        value={serviceType}
                        onChange={(e) => {
                          setServiceType(e.target.value);
                          setSelectedGroups([]);
                        }}
                      >
                        <option value={undefined}>Select one</option>
                        {serviceTypes.map((sType, sTypeIdx) => (
                          <option key={sTypeIdx} value={sType.value}>{sType.label}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="mb-4 row">
                    <label htmlFor="inputPassword" className="col-sm-3 col-form-label label-required">Assign to</label>
                    <div className="col-sm-9">
                      {/* <input type="text" className="form-control" id="inputPassword" /> */}
                      {/* <input className="form-control" list="datalistOptions" id="exampleDataList" placeholder="Type to search..." /> */}
                      <Select
                        classNamePrefix="select2-selection"
                        placeholder="Choose..."
                        title="Groups"
                        options={dispGroups}
                        isMulti
                        value={selectedGroups}
                        onChange={e => { setSelectedGroups(e); }}
                      />
                    </div>
                  </div>

                  <div className="mb-4 row">
                    <label htmlFor="selectAssets" className="col-sm-3 col-form-label label-required">Assets</label>
                    <div className="col-sm-9">
                      {/* <input type="text" className="form-control" id="inputPassword" /> */}
                      {/* <input className="form-control" list="datalistOptions" id="exampleDataList" placeholder="Type to search..." /> */}
                      <Select
                        classNamePrefix="select2-selection"
                        placeholder="Choose..."
                        title="Assets"
                        id="selectAssets"
                        options={assets}
                        isMulti
                        value={selectedAssets}
                        onChange={e => { setSelectedAssets(e); }}
                      />
                    </div>
                  </div>


                  <div className="mb-4 row">
                    <label htmlFor="inputPassword" className="col-sm-3 col-form-label label-required">Vendor</label>
                    <div className="col-sm-9">
                      <Select
                        classNamePrefix="select2-selection"
                        placeholder="Choose one..."
                        title="Vendor"
                        options={vendors}
                        value={vendor}
                        onChange={e => {
                          setContract(null);
                          setVendor(e);
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="inputPassword" className="col-sm-3 col-form-label label-required">Contract</label>
                    <div className="col-sm-9">
                      <Select
                        classNamePrefix="select2-selection"
                        placeholder="Choose one..."
                        title="Contract"
                        options={dispContracts}
                        value={contract}
                        onChange={e => { setContract(e); }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <CardTitle tag="h3">SCHEDULE</CardTitle>
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="mt-4 mb-4 row">
                <label htmlFor="inputStartDate" className="col-sm-3 col-form-label label-required">Start date</label>
                <div className="col-sm-9">
                  <input className="form-control" id="inputStartDate"
                    type="date"
                    value={startDate}
                    onChange={e => {
                      setStartDate(e.target.value);
                    }}
                  />
                  {contract &&
                    <div className="mt-1 text-muted">
                      Contract start date : {moment(contract.start_date).format('DD MMM YYYY')}
                    </div>
                  }
                </div>
              </div>
              <div className="mb-4 row">
                <label htmlFor="inputEndDate" className="col-sm-3 col-form-label label-required">End date</label>
                <div className="col-sm-9">
                  <input className="form-control" id="inputEndDate"
                    type="date"
                    value={endDate} onChange={e => {
                      setEndDate(e.target.value);
                    }}
                  />
                  {contract &&
                    <div className="mt-1 text-muted">
                      Contract expiry date : {moment(contract.end_date).format('DD MMM YYYY')}
                    </div>
                  }
                </div>
              </div>

              <div className="mb-4 row">
                <label htmlFor="staticEmail" className="col-sm-3 col-form-label label-required">Frequency type</label>
                <div className="col-sm-9">
                  {/* <input type="text" className="form-control" id="inputPassword" /> */}
                  <select className="form-control" placeholder="Select"
                    value={type}
                    onChange={e => {
                      setType(e.target.value);
                    }}
                  >
                    <option value="Weekly">Weekly</option>
                    <option value="Fortnightly">Fortnightly</option>
                    <option value="Monthly">Monthly</option>
                    <option value="Bi-Monthly">Bi-Monthly</option>
                    <option value="Quarterly">Quarterly</option>
                    <option value="Half-Yearly">Half-Yearly</option>
                    <option value="Yearly">Yearly</option>
                  </select>
                </div>
              </div>

              <div className="mb-4 row">
                <div className="col-sm-3">
                  <label htmlFor="inputEndDate" className="col-form-label label-required">Repeat Every</label>
                  {/* <div className="form-check form-switch form-switch-md">
                      <input type="checkbox" id="checkbox_1" className="form-check-input checkbox"
                        checked={enableRepeat}
                        onChange={() => { setEnableRepeat(!enableRepeat); }}
                      />
                      <label className="form-check-label" htmlFor="checkbox_1">
                      {enableRepeat ? 'Enabled' : 'Disabled'}
                      </label>
                    </div> */}
                </div>
                <div className="col-sm-9 pt-2">
                  <div className="d-flex align-items-center">
                    <div className="flex-1">
                      <input type="text" className="form-control" id="inputPassword"
                        type="number"
                        min={1}
                        disabled={!enableRepeat}
                        value={repeatVal}
                        onChange={(e) => {
                          setRepeatVal(e.target.value);
                        }}
                      />
                    </div>
                    <div className="ps-2 flex-1">
                      <select className="form-control" placeholder="Select"
                        value={repeatUnit}
                        disabled={!enableRepeat}
                        onChange={e => {
                          setRepeatUnit(e.target.value);
                        }}
                      >
                        <option value="Days">Days</option>
                        <option value="Weeks">Weeks</option>
                        <option value="Months">Months</option>
                        <option value="Years">Years</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-4 row">
                <label htmlFor="inputDurationVal" className="col-sm-3 col-form-label label-required">Task Duration</label>

                <div className="col-sm-9 pt-2">
                  <div className="d-flex align-items-center">
                    <div className="flex-1">
                      <input type="text" className="form-control" id="inputPassword"
                        type="number"
                        min={1}
                        disabled={!enableRepeat}
                        value={durationVal}
                        onChange={(e) => {
                          setDurationVal(e.target.value);
                        }}
                      />
                    </div>
                    <div className="ps-2 flex-1">
                      <select className="form-control" placeholder="Select"
                        value={durationUnit}
                        onChange={e => {
                          setDurationUnit(e.target.value);
                        }}
                      >
                        <option value="Days">Days</option>
                        <option value="Weeks">Weeks</option>
                        <option value="Months">Months</option>
                        <option value="Years">Years</option>
                      </select>
                    </div>
                  </div>
                </div>




              </div>


              <div className="mb-4 row">
                <div className="col-sm-3">
                  <label htmlFor="inputEndDate" className="col-form-label">
                    Overdue</label>
                  <div className="form-check form-switch form-switch-md">
                    <input type="checkbox" id="checkbox_1" className="form-check-input checkbox"
                      checked={enableOverdue}
                      onChange={() => { setEnableOverdue(!enableOverdue); }}
                    />
                    <label className="form-check-label" htmlFor="checkbox_1">
                      {enableOverdue ? 'Enabled' : 'Disabled'}
                    </label>
                  </div>
                </div>
                <div className="col-sm-7">
                  <input type="number" min={1} className="form-control" id="inputOverdue"
                    value={overdue} disabled={!enableOverdue} onChange={e => {
                      setOverdue(e.target.value);
                    }}
                  />
                  <div className="text-muted mt-1">
                    {enableOverdue ?
                      ((!isNaN(overdue) && overdue > 0) ?
                        'Task will be marked as overdue ' + overdue + ' day' + (overdue > 1 ? 's' : '') + ' before task duration ends'
                        :
                        'Please enter a valid number greater than zero')
                      :
                      'Overdue not enabled'
                    }
                  </div>
                </div>
                <div className="col-sm-2 text-muted pt-2">
                  days before
                  </div>
              </div>


            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <CardTitle tag="h3">FORM <span className="text-danger">*</span></CardTitle>
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="mt-4">
                {/* <label htmlFor="inputPassword" className="col-sm-3 col-form-label">Building Code</label> */}
                {/* <input type="text" className="form-control" id="inputPassword" placeholder="Select one.." /> */}

                <Select
                  classNamePrefix="select2-selection"
                  placeholder="Choose..."
                  title="Form"
                  options={forms}
                  // isMulti
                  value={formId}
                  onChange={e => {
                    setFormId(e);
                    fetchForm(e.value);
                  }}
                  noOptionsMessage={() => "No forms found"}
                />
              </div>
              {formId && fields.length > 0 &&
                <div className="mt-4">
                  <Card outline color="primary" className="border">
                    <CardBody>
                      <CardTitle className="mt-0">Preview</CardTitle>
                      <Table className="table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th>Label</th>
                            <th>Field</th>
                            {/* <th>Field Lower limit</th>
                <th>Field Upper limit</th>
                <th>Warning Lower limit</th>
                <th>Warning Upper limit</th>
                <th>Alert on</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {fields.map((field, fieldIdx) => (
                            <tr key={fieldIdx}>
                              {/* <th scope="row">{fieldIdx+1}</th> */}
                              <td>{field.label}</td>
                              <td>
                                {
                                  field.type == 'text' ? <input className="form-control" type="text" /> :
                                    field.type == 'number' ? <input className="form-control" type="number" /> :
                                      field.type == 'textarea' ? <textarea className="form-control" rows={4} ></textarea> :
                                        field.type == 'remark' ? <textarea className="form-control" rows={4} ></textarea> :
                                          field.type == 'radio' ? <div className="">
                                            {field.options.split(',').map((opt, optIndex) => (
                                              <div className="form-check mb-2" key={optIndex}>
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  value={opt}
                                                />
                                                <label
                                                  className="form-check-label"
                                                >
                                                  {opt}
                                                </label>
                                              </div>
                                            ))}
                                          </div> :
                                            field.type}
                              </td>
                              {/* <td>
                  {field.min}
                </td>
                <td>
                  {field.max}
                </td>
                <td>
                  {field.warning_min}
                </td>
                <td>
                  {field.warning_max}
                </td>
                <td>
                  {field.alert_on == 'null' ? '' : field.alert_on}
                </td> */}
                            </tr>
                          ))}
                        </tbody>
                      </Table>


                    </CardBody>
                  </Card>
                </div>
              }
            </CardBody>
          </Card>





        </Container>

        <div className="mb-4 container">
          <div className="d-flex justify-content-center">
            <button type="button" className="btn btn-primary me-2"
              onClick={() => { handleSubmit(); }}
              disabled={!props.filterBlock}
            >
              Submit
          </button>
            <Link className="btn btn-light" to="/ppmactivities/index">Cancel</Link>
          </div>
        </div>
      </div>



    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(NewPpmactivity)